import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { audience } from '../data/content';
export function Audience() {
  return <section aria-labelledby="audience-title" className="bg-dusk" data-id="element-19" data-mp="3p1x6co88xakz">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:py-24" data-id="element-20" data-mp="6uzmy81ik4pg">
        <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-21" data-mp="1vd8jv9y8if2">
          <p className="font-display text-lg font-semibold text-pumpkin" data-id="element-22" data-mp="1xzg3uwuaxxa">¿Para quién es?</p>
          <h2 id="audience-title" className="mt-3 font-display text-4xl font-bold leading-tight text-bone sm:text-5xl" data-id="element-23" data-mp="gqkj3pjwiara">
            Diseñado para vos si querés que tu Halloween familiar sea inolvidable
          </h2>
          <a href="#garantia" className="mt-8 inline-flex items-center gap-2 font-semibold text-pumpkin-soft underline-offset-4 transition-colors duration-150 ease-out hover:text-pumpkin hover:underline" data-id="element-24" data-mp="ljm4mgem58ju">
            ¿No estás segura si es para vos? Tenés 7 días de garantía
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="ui7i3x589xdr" />
          </a>
        </div>

        <ul className="divide-y divide-line" data-id="element-26" data-mp="16f2qgvag6fgu">
          {audience.map(a => <li key={a.title} className="py-7 first:pt-0 last:pb-0" data-id="element-27" data-mp="1bckzelogsuou">
              <h3 className="flex flex-wrap items-center gap-3 font-display text-2xl font-semibold text-bone" data-id="element-28" data-mp="1gaw8uvaul36j">
                {a.title}
                {a.isNew && <span className="rounded-md bg-slime px-2 py-0.5 font-sans text-xs font-extrabold text-night" data-id="element-29" data-mp="1pbu4oqb4u4e1">NUEVO</span>}
              </h3>
              <p className="mt-2 text-lg leading-relaxed text-mist" data-id="element-30" data-mp="1u9ch4qocz1qs">{a.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}